import React from 'react';
import { Box, Container, Typography, Link, Grid, IconButton } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useShell } from './ShellContext';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';

const DARK = '#05080F';
const LIME = '#00F1A7';
const PURPLE = '#00F1A7';

function Footer() {
  const navigate = useNavigate();
  const inShell = useShell();
  if (inShell) return null;

  const links = [
    { label: 'Quem Somos', path: '/quem-somos' },
    { label: 'Início', path: '/' },
    { label: 'Recursos', path: '/recursos' },
    { label: 'Planos', path: '/cadastrar-igreja' },
    { label: 'Meus Cursos', path: '/meus-cursos' },
    { label: 'Privacidade e LGPD', path: '/privacidade' },
    { label: 'Termos de Uso', path: '/termos' },
    { label: 'Regras de Teste', path: '/regras-teste' },
  ];

  const recursos = [
    { label: 'Consolidação', path: '/recursos' },
    { label: 'Start', path: '/recursos' },
    { label: 'Secretaria', path: '/recursos' },
    { label: 'Cursos e Treinamentos', path: '/recursos' },
    { label: 'Discipulado', path: '/recursos' },
    { label: 'Grupos de Crescimento', path: '/recursos' },
    { label: 'Jornada do Membro', path: '/recursos' },
    { label: 'Voluntariado', path: '/recursos' },
    { label: 'Notificações', path: '/recursos' },
    { label: 'Financeiro', path: '/recursos' },
  ];

  return (
    <Box component="footer" sx={{ bgcolor: DARK, color: '#93A7A3', mt: 'auto' }}>
      <Container maxWidth="lg" sx={{ py: { xs: 5, md: 7 } }}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Box component="img" src="/images/logo_conecta_church_white_v2.svg" alt="ConectaChurch"
              sx={{ height: 44, width: 'auto', display: 'block', mb: 1.5 }}
              onError={(e) => { e.target.style.display = 'none'; }} />
            <Typography variant="body2" sx={{ color: '#888', mb: 2, lineHeight: 1.8, maxWidth: 300 }}>
              Plataforma completa de gestão eclesiástica. Consolidação, secretaria, cursos, discipulado,
              financeiro e muito mais para sua comunidade.
            </Typography>
            <Box sx={{ display: 'flex', gap: 0.5 }}>
              <IconButton size="small" sx={{ color: '#888', '&:hover': { color: LIME } }} component="a" href="https://instagram.com/smyrnacore" target="_blank">
                <InstagramIcon fontSize="small" />
              </IconButton>
              <IconButton size="small" sx={{ color: '#888', '&:hover': { color: LIME } }} component="a" href="https://linkedin.com/company/smyrnacore" target="_blank">
                <LinkedInIcon fontSize="small" />
              </IconButton>
              <IconButton size="small" sx={{ color: '#888', '&:hover': { color: LIME } }} component="a" href="https://youtube.com/@smyrnacore" target="_blank">
                <YouTubeIcon fontSize="small" />
              </IconButton>
            </Box>
          </Grid>

          <Grid item xs={6} md={2}>
            <Typography variant="subtitle2" sx={{ color: '#fff', fontWeight: 700, mb: 1.5 }}>
              Links
            </Typography>
            {links.map(l => (
              <Link key={l.label} onClick={() => navigate(l.path)}
                sx={{ display: 'block', color: '#888', fontSize: '0.85rem', py: 0.4, cursor: 'pointer', textDecoration: 'none', '&:hover': { color: LIME } }}>
                {l.label}
              </Link>
            ))}
          </Grid>

          <Grid item xs={6} md={3}>
            <Typography variant="subtitle2" sx={{ color: '#fff', fontWeight: 700, mb: 1.5 }}>
              Módulos
            </Typography>
            {recursos.map(r => (
              <Link key={r.label} onClick={() => navigate(r.path)}
                sx={{ display: 'block', color: '#888', fontSize: '0.85rem', py: 0.4, cursor: 'pointer', textDecoration: 'none', '&:hover': { color: LIME } }}>
                {r.label}
              </Link>
            ))}
          </Grid>

          <Grid item xs={12} md={3}>
            <Typography variant="subtitle2" sx={{ color: '#fff', fontWeight: 700, mb: 1.5 }}>
              Contato
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
              <EmailIcon sx={{ fontSize: 16, color: PURPLE }} />
              <Typography variant="body2" sx={{ color: '#888', fontSize: '0.85rem' }}>
                contato@smyrnacore.com.br
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
              <PhoneIcon sx={{ fontSize: 16, color: PURPLE }} />
              <Typography variant="body2" sx={{ color: '#888', fontSize: '0.85rem' }}>
                WhatsApp (81) 99600-1383
              </Typography>
            </Box>
            <Link
              onClick={() => navigate('/cadastrar-igreja')}
              sx={{
                display: 'inline-block', bgcolor: PURPLE, color: '#fff', px: 2, py: 0.8, borderRadius: 1,
                fontSize: '0.8rem', fontWeight: 700, textDecoration: 'none', cursor: 'pointer',
                '&:hover': { bgcolor: '#00C48C' },
              }}
            >
              Cadastrar minha igreja
            </Link>
          </Grid>
        </Grid>
      </Container>

      <Box sx={{ borderTop: '1px solid #333', py: 2.5, textAlign: 'center' }}>
        <Container maxWidth="lg">
          <Typography variant="caption" sx={{ color: '#666', fontSize: 11 }}>
            © {new Date().getFullYear()} ConectaChurch — Sistema de Gestão Eclesiástica. Todos os direitos reservados.
            Powered by <Link href="https://smyrnacore.com.br" target="_blank" rel="noopener" sx={{ color: LIME, textDecoration: 'none', '&:hover': { color: '#d4ef80' } }}>SmyrnaCore</Link> — CNPJ 66.330.452/0001-40
          </Typography>
        </Container>
      </Box>
    </Box>
  );
}

export default Footer;
